export const DND_NEW_EVENT_DURATION_IN_MINUTES = 30;
export const CUSTOM_VIEW_KEY_PREFIX = 'planner:custom_view';
export const LAST_CUSTOM_DAYS_KEY_PREFIX = 'planner:last_custom_days';
export const WEEKEND_VIEW_KEY_PREFIX = 'planner:weekend_view';
export const GOOGLE_SERVICE_KEY = 'trello-planner-google-calendar';
export const OUTLOOK_SERVICE_KEY = 'trello-planner-outlook-calendar';
export const PLANNER_FEATURE_DISCOVERY_MESSAGE_ID =
  'planner-feature-discovery-message';
export const DUE_DATE_CARDS_PAGE_SIZE = 20;
export const EVENTS_PAGE_SIZE = 50;
export const EVENTS_INITIAL_PAGE_SIZE_MONTH_VIEW = 150;
// Name of the spotlight target wrapping the due-date-card (or its
// placeholder) for the June 2026 feature announcement. Lives here rather
// than next to its `SpotlightTarget` consumer so both that consumer and
// the spotlight definition can import it without a circular dependency.
export const DUE_DATE_CARD_FEATURE_ANNOUNCEMENT_SPOTLIGHT_TARGET =
  'due-date-card-feature-announcement-placeholder-target';

/**
 * `localStorage`-key prefix for the Planner view-mode preference. The full
 * key is `${VIEW_MODE_KEY_PREFIX}:${memberId ?? 'anonymous'}` — the suffix
 * scopes the value per user so two members signed in on the same machine
 * never collide.
 */
export const VIEW_MODE_KEY_PREFIX = 'planner:schedule_view_mode' as const;

/**
 * `localStorage`-key prefix for Schedule View per-day collapse state.
 * Member-scoped at the call site so two members on the same machine
 * don't collide.
 */
export const DAY_COLLAPSE_KEY_PREFIX = 'planner:days_collapsed' as const;

/**
 * Maximum character length for editable event titles. Uses the lower-bound
 * across calendar providers (Google Calendar, Outlook) to ensure compatibility.
 */
export const EVENT_TITLE_MAX_LENGTH = 200;
